export function refactorMessages(rawMessages) {
  if (!rawMessages || typeof rawMessages !== 'object') {
    return []
  }

  return Object.entries(rawMessages).map(([key, message]) => {
    return {
      messageId: key,
      message: message.text || '',
      timestamp: message.timestamp || new Date().toUTCString(),
      sentBy: message.from || 'user',
      sentByName: message.from_name || null,
      adminUserId: message.admin_user_id || null,
    }
  })
}

export function createDemoMessage(messageText) {
  return {
    messageId: `temp-${Date.now()}`,
    message: messageText,
    timestamp: new Date().toUTCString(),
    sentBy: 'user',
    sentByName: null,
  }
}
